module.exports = __webpack_public_path__ + "img/歌中歌logo图.7e72bade.png";